import React, { useState, useEffect } from "react";
import {
	HorizontalList,
	Text,
	VerticalList,
	CloudinaryImage,
	Grid,
	Card,
	Col,
	Button,
	RequestSyllabusButton,
	Separator,
} from "@website-builder/ui/shared/elements";
import { HypeCardWrapper, ListItemWrapper } from "./style";
import { useMediaQuery } from "@react-hook/media-query";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
import { isBusinessVerticalB2U } from "@website-builder/utilities/utils/helpers.js";
import {
	formatColor,
	handleCTAClick,
} from "@website-builder/utilities/utils/DesignUtils.js";
const isB2U = isBusinessVerticalB2U();
const HypeCard = (props) => {
	const {
		backgroundColor,
		salarySection,
		title,
		listItems,
		listHeader,
		logoBar,
		logoBarLabel,
		ctaDescription,
		cta = {},
		context = {},
		maxLogosInRow = 0,
		pageSection = "",
		workshopId = "",
		listIconColor = "",
	} = props;
	const iconConfig = {
		iconName: "checkCircle",
		color: "var(--primary-forest-400)",
		size: "1.5rem",
		stroke: listIconColor,
	};
	// checks for mobile width
	const satisfiesMobileWidth = useMediaQuery(`(max-width: ${TABLET_M_BP}px)`);
	const [isMobile, setIsMobile] = useState(undefined);
	useEffect(() => {
		setIsMobile(satisfiesMobileWidth);
	}, [satisfiesMobileWidth]);
	return (
		<HypeCardWrapper
			salaryHeadingColor={formatColor(salarySection?.salaryHeadingColor)}
			className="hype-card"
			backgroundColor={backgroundColor}
		>
			<Grid>
				<Col start={1} span={12} mdStart={1} mdSpan={6}>
					<Card className="card-container" bgColor={backgroundColor}>
						<Text className="card-header" variant="headline_3" tag="h2">
							{title}
						</Text>
						<Grid className="bottom-container">
							<Col
								start={1}
								span={3}
								mdStart={1}
								mdSpan={6}
								className="left-section"
							>
								{salarySection?.salary ? (
									<Text className="salary-heading" tag="p" variant="headline_0">
										{salarySection?.salary}
									</Text>
								) : null}
								{salarySection?.title ? (
									<Text className="salary-title" variant="paragraph_S">
										{salarySection?.title}
									</Text>
								) : null}
								{salarySection?.description ? (
									<Text className="salary-description" variant="paragraph_S">
										{salarySection?.description}
									</Text>
								) : null}
							</Col>

							<Col
								className="middle-section"
								start={4}
								span={6}
								mdStart={1}
								mdSpan={6}
							>
								{!isMobile ? (
									<div>
										<Separator vertical color="rgba(5, 8, 43, 0.3)" />
									</div>
								) : null}
								<div className="content-section">
									{listHeader && (
										<Text className="list-header" variant="paragraph_S">
											{listHeader}
										</Text>
									)}
									{listItems?.length ? (
										<VerticalList
											className="veritcal-list"
											iconConfig={iconConfig}
											listItems={listItems.map(({ text = "" }, index) => {
												return (
													<ListItemWrapper key={index}>
														<Text
															className="item-description"
															variant="paragraph_M_bold"
															tag="div"
														>
															{text}
														</Text>
													</ListItemWrapper>
												);
											})}
											gap="1rem"
										/>
									) : null}
									{logoBarLabel ? (
										<Text variant="paragraph_S" className="icon-header">
											{logoBarLabel}
										</Text>
									) : null}
									{logoBar?.length ? (
										<HorizontalList
											className="logo-list"
											maxItems={maxLogosInRow}
											listItems={logoBar?.map(
												({
													image: { image: imageUrl = "", altTag = "" } = {},
												}) => (
													<CloudinaryImage
														url={imageUrl}
														alt={altTag}
														lazyload
														sizes={{
															default: {
																width: 110,
															},
														}}
														className="logo-img hype-card-logo"
													/>
												),
											)}
											gap="24px"
										/>
									) : null}
								</div>
								{!isMobile ? (
									<div>
										<Separator vertical color="rgba(5, 8, 43, 0.3)" />
									</div>
								) : null}
							</Col>
							<Col
								start={10}
								span={3}
								mdStart={1}
								mdSpan={6}
								className="right-section"
							>
								{ctaDescription ? (
									<Text
										variant="paragraph_M"
										className="cta-description"
										tag="div"
										dangerouslySetInnerHTML={{
											__html: ctaDescription,
										}}
									></Text>
								) : null}
								{cta?.component === "RequestSyllabusWR" ? (
									<RequestSyllabusButton
										{...cta}
										type={cta?.type}
										requestFormType={cta?.requestFormType}
										context={context}
										isDarkBg={cta?.isDarkBg}
										disabled={cta?.disabled}
										pageSection={pageSection}
										workshopId={workshopId}
										modalId={`hype-card-${workshopId}-request-syllabus-modal`}
									/>
								) : (
									<Button
										{...cta}
										buttonConfiguration={isB2U ? cta : undefined}
										buttonText={cta?.buttonText}
										type={cta?.type}
										isDarkBg={cta?.isDarkBg}
										disabled={cta?.disabled}
										onClick={() =>
											handleCTAClick(cta, {
												page_section: pageSection,
												click_text: cta?.buttonText,
												redirect_to: cta?.link?.link,
											})
										}
									/>
								)}
							</Col>
						</Grid>
					</Card>
				</Col>
			</Grid>
		</HypeCardWrapper>
	);
};
export default HypeCard;
